import {DimensionFormValues, Product, ProductFormValues} from '../types';

// A new product opens with one pricing unit and one price row, so the form
// starts where the operator has to go anyway.
export const emptyDimension = (): DimensionFormValues => ({
    name: '',
    description: '',
    unit: '',
    kind: 'FLAT',
    prices: [{term: 'MONTHLY', amount: '', currency: 'USD'}],
});

export const emptyProductValues = (): ProductFormValues => ({
    name: '',
    summary: '',
    description: '',
    eulaUrl: '',
    supportContact: '',
    dimensions: [emptyDimension()],
});

// The edit form is seeded from the record, field by field: only what the form
// edits, with null turned into the empty string a text input needs. The stored
// dimensionId rides along so the update can send it back.
export const buildInitialValues = (record: Product): ProductFormValues => ({
    name: record.name,
    summary: record.summary,
    description: record.description,
    eulaUrl: record.eulaUrl,
    supportContact: record.supportContact,
    dimensions: record.dimensions.map(dimension => ({
        dimensionId: dimension.dimensionId,
        name: dimension.name,
        description: dimension.description ?? '',
        unit: dimension.unit,
        kind: dimension.kind,
        usageSource: dimension.usageSource ?? null,
        prices: dimension.prices.map(price => ({
            term: price.term ?? '',
            amount: price.amount,
            currency: price.currency,
        })),
    })),
});
